import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-nero-card py-16 md:py-24" data-id="element-91">
      <div className="max-w-3xl mx-auto px-4" data-id="element-92">
        <div className="border-2 border-soft-gold rounded-2xl p-8 md:p-12 text-center bg-black shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-93">
          <ShieldCheck className="w-12 h-12 text-soft-gold mx-auto mb-6" data-id="element-94" />
          <h2 className="text-soft-gold text-2xl md:text-3xl font-bold mb-4 font-playfair" data-id="element-95">
            7-DAY GUARANTEE / NO QUESTIONS ASKED
          </h2>
          <p className="text-white text-base md:text-lg mb-6 leading-relaxed" data-id="element-96">
            Download the MegaPack. Read the volumes. Use the templates. If you
            don't feel like this is the best investment you've made in your PT
            business, email us within 7 days and we'll give you a
          </p>
          <p className="text-soft-gold text-3xl md:text-4xl font-bold mb-4" data-id="element-97">
            100% refund
          </p>
          <p className="text-white text-sm md:text-base mb-6 uppercase tracking-wider" data-id="element-98">
            no forms · no drama · no explanations.
          </p>
          <p className="text-gray-500 italic text-xs md:text-sm" data-id="element-99">
            Refund rate: less than 1%.
          </p>
        </div>
      </div>
    </section>;
}